"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _SegmentList = _interopRequireDefault(require("../../components/SegmentList"));

var _removeSelectedPersona = require("../../actions/selectedPersonas/removeSelectedPersona");

var _actions = require("../../actions");

var _groupedPersona = require("../../actions/groupedPersonas/groupedPersona");

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _ActiveSegmentList = _interopRequireDefault(require("../../components/CampaignCreator/SelectSegments/ActiveSegmentList"));

var _Sidebar = _interopRequireDefault(require("../../components/CampaignCreator/Sidebar"));

var _semanticUiReact = require("semantic-ui-react");

var _index = require("../../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SelectPersonas = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SelectPersonas, _React$Component);

  function SelectPersonas(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "toggleSidebar", function () {
      _this.setState(_extends({}, _this.state, {
        showSidebar: !_this.state.showSidebar
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckBoxAction", function () {
      _this.props.loadGroupedPersona();
    });

    _this.state = {
      showSidebar: false
    };
    return _this;
  }

  var _proto = SelectPersonas.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.loadSuperSegments();
    this.props.featureAccess();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        selectedPersonas = _this$props.selectedPersonas,
        removeSelectedPersona = _this$props.removeSelectedPersona,
        superSegments = _this$props.superSegments,
        campaignCreatorAccess = _this$props.campaignCreatorAccess;
    var showSidebar = this.state.showSidebar;

    var Title = function Title() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_semanticUiReact.Icon, {
        className: "grouped-personas__icon",
        name: "bars",
        size: "large",
        onClick: _this2.toggleSidebar
      }), /*#__PURE__*/React.createElement("h2", {
        className: "grouped-personas__sub-title"
      }, "Select Personas"));
    };

    return /*#__PURE__*/React.createElement("div", null, campaignCreatorAccess ? /*#__PURE__*/React.createElement("div", {
      className: "campaign-creator-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grouped-personas__row"
    }, /*#__PURE__*/React.createElement(_Sidebar["default"], {
      open: showSidebar,
      title: /*#__PURE__*/React.createElement(Title, null),
      body: /*#__PURE__*/React.createElement("div", {
        className: "scroll-box"
      }, /*#__PURE__*/React.createElement(_SegmentList["default"], {
        expanded: true,
        handleCheckBoxAction: this.handleCheckBoxAction
      }))
    }), /*#__PURE__*/React.createElement("div", {
      className: "select-personas__body"
    }, /*#__PURE__*/React.createElement(_ActiveSegmentList["default"], {
      removePersona: removeSelectedPersona,
      personas: selectedPersonas,
      superSegments: superSegments
    })))) : '');
  };

  return SelectPersonas;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  var workflowPermission = state.options.permissions && state.options.permissions.workflowPermission;
  return {
    selectedPersonas: state.selectedPersonas.personas,
    superSegments: state.superSegments.bySlug,
    // Finish off changing to super segments
    campaignCreatorAccess: state.featureAccess.byId && state.featureAccess.byId[workflowPermission] && state.featureAccess.byId[workflowPermission].hasAccess
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    removeSelectedPersona: _removeSelectedPersona.removeSelectedPersona,
    loadSuperSegments: _actions.loadSuperSegments,
    featureAccess: _index.featureAccess,
    loadGroupedPersona: _groupedPersona.loadGroupedPersona
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SelectPersonas);

exports["default"] = _default;